export default (date: string): string => {
  const formatted = date.match(/.{1,2}/g);
  if (!formatted) return '';
  return `${formatted[3]}/${formatted[2]}/${formatted[0] + formatted[1]} ${
    formatted[4]
  }:${formatted[5]}`;
};
